import React from "react";
import { ListGroup } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import {
	FaTachometerAlt,
	FaAd,
	FaCalendarAlt,
	FaUserFriends,
	FaBiking,
	FaPoll,
	FaImage,
	FaCamera,
	FaFutbol,
	FaUsers,
	FaVideo,
	FaLockOpen,
	FaChartBar,
	FaNewspaper,
	FaGift,
	FaStar,
} from "react-icons/fa";

const adminNavItems = [
	{ path: "/admin", label: "Dashboard", icon: FaTachometerAlt },
	{ path: "/admin/analytics", label: "Analytics Manager", icon: FaChartBar },
	{ path: "/admin/admanager", label: "Ad Manager", icon: FaAd },
	{ path: "/admin/disable", label: "Disable Manager", icon: FaLockOpen },
	{ path: "/admin/events", label: "Event Manager", icon: FaCalendarAlt },
	{ path: "/admin/leagues", label: "League Manager", icon: FaUserFriends },
	{ path: "/admin/riders", label: "Rider Manager", icon: FaBiking },
	{ path: "/admin/upload-riders", label: "Upload Riders", icon: FaBiking },
	{ path: "/admin/results", label: "Result Manager", icon: FaPoll },
	{ path: "/admin/snapshots", label: "Snapshot Manager", icon: FaImage },
	{ path: "/admin/sports", label: "Sport Manager", icon: FaFutbol },
	{ path: "/admin/teams", label: "Team Manager", icon: FaUsers },
	{ path: "/admin/users", label: "User Manager", icon: FaUserFriends },
	{ path: "/admin/watch", label: "Watch Manager", icon: FaCamera },
	{ path: "/admin/videos", label: "Video Manager", icon: FaVideo },
	{ path: "/admin/blogs", label: "Blog Manager", icon: FaNewspaper },
	{ path: "/admin/prizes", label: "Prize Manager", icon: FaGift },
	{ path: "/admin/featured", label: "Featured Manager", icon: FaStar },
	{ path: "/admin/seasons", label: "Season Manager", icon: FaCalendarAlt },
	{ path: "/admin/brandteams", label: "Brand Team Manager", icon: FaCamera },
];

const AdminNavList = ({ onNavigate, className = "" }) => {
	const navigate = useNavigate();
	const location = useLocation();

	const handleNavigate = (path) => {
		navigate(path);
		if (onNavigate) {
			onNavigate();
		}
	};

	return (
		<ListGroup variant="flush" className={`admin-nav-list ${className}`.trim()}>
			{adminNavItems.map((item) => {
				const Icon = item.icon;
				const isActive = location.pathname === item.path;
				return (
					<ListGroup.Item
						action
						key={item.path}
						active={isActive}
						onClick={() => handleNavigate(item.path)}
						className="admin-nav-item"
					>
						<Icon className="me-2" />
						{item.label}
					</ListGroup.Item>
				);
			})}
		</ListGroup>
	);
};

export default AdminNavList;
